<template>
	<div class="mainRight">
		<publicHotTag />
		<clickRanking :data="data" />
		<!-- <myCard/> -->
	</div>
</template>

<script>
	// import myCard from './myCard'
	import publicHotTag from '@/components/common/hotTag'
	import clickRanking from './clickRanking'
	
	import axios from '@/axios/'

	export default {
		components: {
			// myCard,
			publicHotTag,
			clickRanking
		},
		data(){
			return{
				data:[],
			}
		},
		async created(){
			try{
				let {data} = await axios('/index/ranking/list');
				if(data.code==200){
					this.data = data.data;
				}
			}catch(e){
				//
			}
		}
	}
</script>

<style scoped>
	.mainRight {
		width: 330px;
		float: right;
	}
</style>
